'use es6';

import * as AppActions from './AppActions';
export default Object.assign({}, AppActions);